import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface ProfileState {
  name: string;
  setName: (value: string) => void;

  lastName: string;
  setLastName: (value: string) => void;

  emailId: string;
  setEmailId: (value: string) => void;

  stage: any;
  setStage: (value: any) => void;

  field: any;
  setField: (value: any) => void;

  role: any;
  setRole: (value: any) => void;

  interest: any;
  setInterest: (value: any) => void;

  profileImage: any;
  setProfileImage: (value: any) => void;

  profileImageSize: number;
  setProfileImageSize: (value: any) => void;

  careerPaths: {
    [key: string]: any;
  };
  setCareerPaths: (values: { [key: string]: any }) => void;

  setProfileValues: (
    arg: Pick<ProfileState, 'name' | 'lastName' | 'emailId' | 'careerPaths' | 'profileImage'>
  ) => void;
  //| 'stage' | 'field' | 'role' | 'interest'
}

export const useProfileStore = create<ProfileState, [['zustand/devtools', ProfileState]]>(
  devtools((set) => ({
    name: '',
    setName: (name) => set({ name: name }),

    lastName: '',
    setLastName: (lastName) => set({ lastName: lastName }),

    role: [],
    setRole: (role) => set({ role: role }),

    emailId: '',
    setEmailId: (emailId) => set({ emailId: emailId }),

    stage: [],
    setStage: (stage) => set({ stage: stage }),

    field: [],
    setField: (field) => set({ field: field }),

    interest: [],
    setInterest: (interest) => set({ interest: interest }),

    profileImage: '',
    setProfileImage: (profileImage) => set({ profileImage }),

    setProfileValues: ({ ...values }) => set({ ...values }),

    profileImageSize: 0,
    setProfileImageSize: (profileImageSize) => set({ profileImageSize }),

    careerPaths: {},
    setCareerPaths: ({ ...values }) => set({ careerPaths: values }),
  }))
);
